import { all, takeLatest, put, call, select } from 'redux-saga/effects';

import { apiAppLaunch } from '@dragonfruit/services/apis';
import { actions, types } from '@dragonfruit/redux/termsDialog';
import { logout } from '@dragonfruit/redux/auth';
import { getCurrentRoute } from '@dragonfruit/redux/location';
import { redirectAfterLoggedIn } from '@dragonfruit/sagas/auth';
import { actions as errorActions } from '@dragonfruit/redux/error';

import { LOGIN, OAUTH } from '@dragonfruit/constants/route';

const NEED_REDIRECT_REGEX = new RegExp(`${LOGIN}|${OAUTH}`);

export function* agreeNewTermsDialogFlow() {
  try {
    yield call(apiAppLaunch, { terms_of_service: true });

    yield put(actions.agreeNewTermsSuccess());
    const currentRoute = yield select(getCurrentRoute);

    if (NEED_REDIRECT_REGEX.test(currentRoute)) {
      yield call(redirectAfterLoggedIn);
    }
  } catch (error) {
    yield put(actions.agreeNewTermsFailure(error.message));
    yield put(errorActions.sendError(error));
  }
}

export function* declineNewTermsFlow() {
  // force logout
  yield put(logout());
}

export default function*() {
  yield all([
    takeLatest(types.AGREE_NEW_TERMS_REQUEST, agreeNewTermsDialogFlow),
    takeLatest(types.DECLINE_NEW_TERMS, declineNewTermsFlow),
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/termsDialog.js